module.exports = __webpack_public_path__ + "img/button_prefix_off.abea2622.svg";